import { auth } from '@vanilla/services/AuthService.js';
import { permissions } from '@vanilla/services/PermissionService.js';
import { UserService } from '@vanilla/services/UserService.js';

function sameUserId(a, b) {
    if (a == null || b == null || a === '' || b === '') return false;
    return String(a) === String(b);
}

/**
 * Mirror FilterManager._populateOwnerOptions: own / team / all sales-rep lists.
 * @returns {{ recordScope: string, beyondOwn: boolean, scopedOwners: object[], scopedOwnerIds: string[] }}
 */
export async function resolveDealOwnerScope(assignableUsers = []) {
    const session = auth.getSession();
    await permissions.load().catch(() => {});
    const recordScope = permissions.getModuleScope('deals');
    const beyondOwn = recordScope === 'team' || recordScope === 'all';

    if (recordScope === 'own') {
        const ids = session?.userId ? [String(session.userId)] : [];
        const me = session?.userId
            ? [{ id: session.userId, name: session.name || 'Me' }]
            : [];
        return { recordScope, beyondOwn, scopedOwners: me, scopedOwnerIds: ids };
    }

    let users = Array.isArray(assignableUsers) ? [...assignableUsers] : [];
    if (!users.length) {
        try {
            users = await UserService.getAssignableUsers();
        } catch {
            users = session?.userId
                ? [{ id: session.userId, name: session.name || 'Me' }]
                : [];
        }
    }

    if (recordScope === 'team' && session?.userId) {
        const me = String(session.userId);
        const missingManagers = users.length > 0 && !users.some((u) => u.managerUserId);
        if (missingManagers) {
            try {
                const full = await UserService.getAll();
                if (Array.isArray(full) && full.length) {
                    const assignableIds = new Set(users.map((u) => String(u.id)));
                    users = full.filter((u) => assignableIds.has(String(u.id)) || sameUserId(u.id, me));
                }
            } catch {
                /* keep assignable list */
            }
        }
        users = users.filter((u) => sameUserId(u.id, me) || sameUserId(u.managerUserId, me));
        if (!users.some((u) => sameUserId(u.id, me))) {
            users = [{ id: session.userId, name: session.name || 'Me' }, ...users];
        }
    }

    const scopedOwnerIds = users.map((u) => String(u.id)).filter(Boolean);
    return { recordScope, beyondOwn, scopedOwners: users, scopedOwnerIds };
}
